import Navbar from "./components/Navbar";
import HeroSlider from "./components/HeroSlider";
import ServicesSection from "./components/ServicesSection";
import CTABanner from "./components/CTABanner";
import FAQSection from "./components/FAQSection";
import AboutSection from "./components/AboutSection";
import CommunitySection from "./components/CommunitySection";
import ReviewsSection from "./components/ReviewsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import LiveChat from "./components/LiveChat";
import SEO from "../../components/base/SEO";
import { useEffect } from "react";

const siteUrl: string = (import.meta.env.VITE_SITE_URL as string) ?? '';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": ["HVACBusiness", "LocalBusiness"],
  "name": "Ultimate Heating & Cooling",
  "description": "Connecticut's trusted HVAC specialists. Expert heating, cooling, heat pump, and indoor air quality services in Somers, CT and surrounding areas.",
  "url": siteUrl,
  "telephone": "+19592418524",
  "email": "info@ultimatehvac.com",
  "foundingDate": "2009",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Somers",
    "addressRegion": "CT",
    "postalCode": "06071",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 41.9784,
    "longitude": -72.4487
  },
  "areaServed": {
    "@type": "State",
    "name": "Connecticut"
  },
  "priceRange": "$$",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "bestRating": "5",
    "reviewCount": "500"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "07:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Saturday"],
      "opens": "08:00",
      "closes": "14:00"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "HVAC Services",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Installation & Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Heating System Service & Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Heat Pump Installation" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Indoor Air Quality Services" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "HVAC Maintenance Plans" } }
    ]
  }
};

export default function Home() {
  useEffect(() => {
    const target = sessionStorage.getItem('scrollTarget');
    if (target) {
      sessionStorage.removeItem('scrollTarget');
      const tryScroll = (attempts = 0) => {
        const el = document.getElementById(target);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attempts < 10) {
          setTimeout(() => tryScroll(attempts + 1), 100);
        }
      };
      setTimeout(() => tryScroll(), 300);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Ultimate Heating & Cooling | CT HVAC Heating & Air Conditioning Experts"
        description="Ultimate Heating & Cooling — Connecticut's trusted HVAC specialists. Expert heating, cooling, heat pump, and indoor air quality services in Somers, CT. Call (959)241-8524."
        keywords="HVAC Connecticut, heating cooling Somers CT, heat pump installation CT, AC repair Connecticut, NATE certified HVAC"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSlider />
        <ServicesSection />
        <CTABanner />
        <FAQSection />
        <AboutSection />
        <CommunitySection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
      <LiveChat />
    </div>
  );
}
